import { instance, objectToParams } from './api';

// Listado paginado de leads. Acepta filtros:
// page, limit, status, depositId, interestGender, q.
export const getLeadsList = (args) => instance.get(`/api/v1/leads?${objectToParams(args)}`);

// Detalle de un lead (incluye sus deposits asociados).
export const getLead = (id) => instance.get(`/api/v1/leads/${id}`);

// Alta de lead. El form incluye depositIds (al menos 1) y consent: true.
export const postLead = (form) => instance.post(`/api/v1/leads`, form);

// Edición del lead. Además de los campos de persona, ahora envía depositIds
// para gestionar (sincronizar) los centros asociados del contacto.
export const putLead = (id, form) => instance.put(`/api/v1/leads/${id}`, form);

// Baja de lead.
export const deleteLead = (id) => instance.delete(`/api/v1/leads/${id}`);

// Centros disponibles para el multiselect del alta. Devuelve
// { code, centers: [{ id, name, code }] }.
export const getLeadCenters = () => instance.get(`/api/v1/leads/centers`);

// Export a Excel respetando los mismos filtros del listado. Buffer .xlsx,
// por eso responseType blob.
export const getLeadsExcel = (args) =>
  instance.get(`/api/v1/leads/excel?${objectToParams(args)}`, { responseType: 'blob' });

// --- Notas (timeline del contacto) ---------------------------------------

// Lista de notas del lead, más reciente primero. Devuelve
// { code, notes: [{ id, leadId, body, createdAt, author: { id, name } }] }.
export const getLeadNotes = (leadId) => instance.get(`/api/v1/leads/${leadId}/notes`);

// Añade una nota al timeline. body = { body } -> { code, message }.
export const postLeadNote = (leadId, body) => instance.post(`/api/v1/leads/${leadId}/notes`, { body });

// Borra una nota concreta del timeline -> { code, message }.
export const deleteLeadNote = (leadId, noteId) => instance.delete(`/api/v1/leads/${leadId}/notes/${noteId}`);
